import type { JSX, ReactNode } from 'react';
import { Box, Col, FormParagraph, Row } from '@ksyos/design-system';
import { CircleCountHeading } from '../../../../../../elements/CircleCountHeading';

type HolterInstructionSectionProps = Readonly<{
    count: string;
    description: ReactNode;
    images?: {
        leftImage: {
            alt: string;
            src: string;
        };
        rightImage: {
            alt: string;
            src: string;
        };
    };
    label: string;
}>;

export function HolterInstructionSection(props: HolterInstructionSectionProps): JSX.Element {
    const { count, label, description, images } = props;

    return (
        <>
            <CircleCountHeading
                count={count}
                label={label}
            />
            <FormParagraph>{description}</FormParagraph>
            {images && (
                <Box
                    mb={8}
                    mt={4}
                >
                    <Row columnGap={[2, 4]}>
                        <Col span={6}>
                            <img
                                alt={images.leftImage.alt}
                                src={images.leftImage.src}
                            />
                        </Col>
                        <Col span={6}>
                            <img
                                alt={images.rightImage.alt}
                                src={images.rightImage.src}
                            />
                        </Col>
                    </Row>
                </Box>
            )}
        </>
    );
}
